import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { CardS } from '../../GlobalStyles';
import { AppStore } from '../../store/applicationState';
import { ShowInteractive } from '../../store/interactive/actions';
import { TypeInteractive } from '../../utils/TypeInteractive';
import { EIcons } from '../../utils/globatTypes';
import { TitleBlock } from '../TitleBlock';
import { Links } from './components/Links';
import { Test } from './components/Test';
import { TestResult } from './components/TestResult';
import { VoteResult } from './components/Votes/VoteResult';
import { VotesGroup } from './components/Votes/VotesGroup';
import { Vote } from './components/Votes/Vote';
import { VoteRating } from './components/Votes/VoteRating';
import { VotesRatingGroup } from './components/Votes/VotesRatingGroup';
import { Polls } from './components/Votes/Polls';
import { PollStatus } from './components/Votes/PollStatus';

interface InteractiveProps {}

export const Interactive: React.FC<InteractiveProps> = () => {
  const { Interactive, Sockets } = useSelector((store: AppStore) => store);
  const dispatch = useDispatch();

  const { room } = Sockets;
  const {
    error,
    test,
    link,
    voteRating,
    doneVoteRating,
    loading,
    votesRatingGroup,
    interactive,
    vote,
    testResult,
    voteResult,
    voteRatingResult,
    votesGroup,
    doneVote,
    doneTest,
    doneVoteGroup,
    doneVoteRatingGroup,
    rating,
  } = Interactive;

  React.useEffect(() => {
    if (room) {
      dispatch(
        ShowInteractive.request({
          data: { event_id: room.event_id, roomId: room.absnum },
        })
      );
    }
  }, [dispatch, room]);

  const renderBody = () => {
    if (interactive === TypeInteractive.test && room && test) {
      return <Test test={test} disabled={loading} doneTest={doneTest} room={room} />;
    }
    if (interactive === TypeInteractive.vote && room && vote) {
      return <Vote vote={vote} disabled={loading} doneVote={doneVote} room={room} />;
    }
    if (interactive === TypeInteractive.voteRating && room && voteRating) {
      return <VoteRating vote={voteRating} disabled={loading} doneVoteRating={doneVoteRating} room={room} />;
    }
    if (interactive === TypeInteractive.link && link) {
      return <Links link={link} />;
    }
    if (interactive === TypeInteractive.testResult && testResult) {
      return <TestResult testResult={testResult} />;
    }
    if (interactive === TypeInteractive.voteResult && voteResult) {
      return <VoteResult voteResult={voteResult} />;
    }
    if (interactive === TypeInteractive.rating && rating) {
      return <PollStatus rating={rating} />;
    }
    if (interactive === TypeInteractive.voteRatingResult && voteRatingResult) {
      return <Polls type="review" vote={voteRatingResult} />;
    }
    if (interactive === TypeInteractive.votesGroup && votesGroup) {
      return <VotesGroup votesGroup={votesGroup} disabled={loading} doneVotes={doneVoteGroup} />;
    }
    if (interactive === TypeInteractive.votesRatingGroup && votesRatingGroup) {
      return <VotesRatingGroup votesGroup={votesRatingGroup} doneVotes={doneVoteRatingGroup} disabled={loading} />;
    }
    return null;
  };

  return (
    <WrapperS>
      <div>
        <TitleBlock title="Iнтерактив" icon={EIcons.interactive} />
      </div>
      {!error ? (
        <BodyS>{renderBody()}</BodyS>
      ) : (
        <BodyS>
          <div style={{ color: 'red', marginTop: '20px', textAlign: 'center' }}>
            <span>{error}</span>
          </div>
        </BodyS>
      )}
    </WrapperS>
  );
};

const WrapperS = styled(CardS)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const BodyS = styled.div`
  flex: 1;
  overflow: auto;
`;
